import VueI18n from '../i18n/i18n';
import { SYSTEM_SERVER_ERROR_CODE } from "../enums/enum-system-server-error-code";

class SystemServerErrorHelper {
    getTranslateErrorText(code) {
        const key = Object.keys(SYSTEM_SERVER_ERROR_CODE).find(item => SYSTEM_SERVER_ERROR_CODE[item].code == code);
        if (key) {
            return VueI18n.t('TOAST_NOTIFICATIONS')[SYSTEM_SERVER_ERROR_CODE[key].i18n];
        }
        return '';
    }
  
}

export default new SystemServerErrorHelper();
